import { AddCircle } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StudioNewDesignDialog } from './';

export interface StudioNewDesignButtonProps {
  canUpdate: boolean;
}

export const StudioNewDesignButton = ({ canUpdate }: StudioNewDesignButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        color="primary"
        disabled={!canUpdate}
        onClick={() => setOpen(true)}
        startIcon={<AddCircle />}
        variant="contained"
      >
        {t('pages.studio.buttons.new_design')}
      </Button>

      <StudioNewDesignDialog onClose={() => setOpen(false)} open={open} />
    </>
  );
};
